$shm_ba_filter_item $mol_view
	title \
	count \
	highlight \
	status \on
	attr *
		^
		shm_ba_filter_item_status <= status
	sub /
		<= Check $mol_check_box
			label /
				<= Label $mol_view
					sub /
						<= Title $mol_view
							sub /
								<= Title_text $mol_dimmer
									haystack <= title
									needle <= highlight
						<= Count $mol_view
							sub /
								<= count
			checked? <=> checked? true
		<= Only $mol_button_minor
			title \Только
			click? <=> only? null
		<= Exclude $mol_button_minor
			click? <=> exclude? null
			sub /
				<= Exclude_icon $mol_icon_close
